import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { HTMLAttributes, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
    TransactionParamActionType,
} from '../hooks/usePrepaidCardTransactions';

interface Props extends HTMLAttributes<HTMLDivElement>{
    period: Exclude<TransactionParamActionType, 'nextPage'>;
    setPeriod: (period: Exclude<TransactionParamActionType, 'nextPage'>) => void;
}

function Period(props: Props) {
    const { period, setPeriod, ...rest } = props;
    const { t } = useTranslation('prepaidCard');
    return (
        <TabList variant='solid' {...rest}>
            <TabItem selected={period === 'week'} onClick={() => setPeriod('week')}>
                {t('log.period.week')}
            </TabItem>
            <TabItem selected={period === 'month'} onClick={() => setPeriod('month')}>{t('log.period.month')}</TabItem>
            <TabItem selected={period === 'quarter'} onClick={() => setPeriod('quarter')}>{t('log.period.quarter')}</TabItem>
            <TabItem selected={period === 'all'} onClick={() => setPeriod('all')}>{t('log.period.all')}</TabItem>
        </TabList>
    );
}

export default Period;
